/**
 * Created by andrey on 07.09.17.
 */

const FieldBoostersView = cc.Node.extend({
    ctor: function (boosters) {
        this._super();
        this.boosters = boosters;

        this.setAnchorPoint(0.5, 0.5);
        this.setLocalZOrder(10);
        this.setVisible(false);

        this.shadowView = new ShadowLayer();
        this.shadowView.setLocalZOrder(FieldBoostersView.ZORDER);

        boosters.onSetActiveListener = this.createListener(this.onSetActive.bind(this));
        boosters.onExecuteListener = this.createListener(this.onExecute.bind(this));

        boosters.onGetBoosterView = this.createListener((boosterId) => this.views[boosterId]);

        boosters.onPointerMoveListener = this.createListener(this.onMouseMove.bind(this));

        boosters.on("show", this.showUpAnimation.bind(this), this);
        boosters.on("hide", this.hideAnimation.bind(this), this);

        this.views = {};
        this.boosters.listAll().forEach(function (booster) {
            const ViewClass = booster.getViewClass();

            const view = new ViewClass(booster);
            this.views[booster.id] = view;

            this.addChild(view);
        }, this);

        this.onResize();
    },

    showUpAnimation: function (silent) {
        const basePosition = this.positionFromAlignment(this.calculatePosition());
        const hidingPosition = this.positionFromAlignment(cleverapps.styles.FieldBoostersView.hidingPosition);

        this.setPosition(hidingPosition);
        this.setVisible(false);
        if (silent) {
            this.setVisible(true);
            this.setAlignment(basePosition);
            return;
        }

        this.runAction(new cc.Sequence(
            new cc.DelayTime(cleverapps.styles.FieldBoostersView.delay),
            new cc.Show(),
            new cc.MoveTo(0.4, basePosition).easing(cc.easeIn(1))
        )).setFinalize(() => {
            this.setVisible(true);
            this.setAlignment(this.calculatePosition());
        });
    },

    hideAnimation: function (silent) {
        const hidingPosition = this.positionFromAlignment(cleverapps.styles.FieldBoostersView.hidingPosition);
        if (silent) {
            this.setAlignment(hidingPosition);
            this.setVisible(false);
            return;
        }

        this.runAction(new cc.Sequence(
            new cc.MoveTo(0.15, hidingPosition).easing(cc.easeIn(2)),
            new cc.Hide()
        )).setFinalize(() => {
            this.setVisible(false);
            this.setAlignment(hidingPosition);
        });
    },

    onResize: function () {
        const styles = cleverapps.styles.FieldBoostersView;

        this.setContentSize2(styles.sizes[cleverapps.resolution.mode]);
        this.setAlignment(this.calculatePosition());

        Object.keys(this.views).forEach((id) => {
            const position = cleverapps.styles.UI.BoostersPositions[cleverapps.resolution.mode][id];
            this.views[id].setAlignment(position);
        });
    },

    calculatePosition: function () {
        let position = cleverapps.styles.FieldBoostersView.position[cleverapps.resolution.mode];
        if (cleverapps.styles.UI.BoostersViewPosition) {
            position = cleverapps.styles.UI.BoostersViewPosition[this.boosters.amountAvailable()][cleverapps.resolution.mode];
        }
        return position;
    },

    onSetActive: function () {
        if (this.boosters.active) {
            cleverapps.effects.fire("match3.booster.select");
        } else {
            cleverapps.effects.fire("match3.booster.deselect");
        }

        if (this.boosters.active) {
            this.addShadow();
            this.addPointer();
        } else {
            this.removeShadow();
            this.removePointer();
        }
    },

    onExecute: function () {
        this.removeShadow();

        const pointer = this.pointer;
        if (!pointer) {
            return;
        }

        pointer.stopAllActions();
        pointer.runAction(new cc.Sequence(
            new cc.FadeOut(0.2),
            new cc.CallFunc(this.removePointer.bind(this))
        ));
    },

    addShadow: function () {
        if (Game.currentGame.tutorial && !Game.currentGame.tutorial.finished) {
            return;
        }

        this.shadowView.createShadow();
        this.addInfoView();
        this.moveUp();
    },

    removeShadow: function () {
        this.shadowView.deleteShadow();

        if (this.infoView) {
            this.infoView.hide();

            this.infoView.runAction(new cc.Sequence(
                new cc.DelayTime(0.2),
                new cc.CallFunc(this.moveDown.bind(this)),
                new cc.RemoveSelf()
            ));
        }
    },

    addInfoView: function () {
        if (this.infoView) {
            this.infoView.removeFromParent();
        }

        const scene = cleverapps.Scenes.GetRunningScene();

        this.infoView = new BoosterInfoView(this.boosters.active);
        scene.addChild(this.infoView);

        this.infoView.hide(true);
        this.infoView.show();
    },

    addPointer: function () {
        if (this.pointer) {
            this.pointer.removeFromParent();
        }

        const view = this.views[this.boosters.active.id];

        const pointer = this.pointer = new cc.Sprite(this.boosters.active.icon_moving);
        pointer.setVisible(false);
        cleverapps.Scenes.GetRunningScene().addChild(pointer);

        pointer.setPosition(this.pointer.getRelativeCoordinates(view));
        pointer.setLocalZOrder(100);
        pointer._setGlobalZOrder(true);
    },

    onMouseMove: function (event) {
        if (this.pointer && this.boosters.active) {
            const position = this.pointer.getParent().convertToNodeSpace(event.getLocation());
            this.pointer.setPosition(position);
            this.pointer.setVisible(true);
            this.pointer.mouseMoved = true;

            this.boosters.onTouchMoved(event);
        }
    },

    removePointer: function () {
        if (this.pointer) {
            this.pointer.removeFromParent();
            delete this.pointer;
        }
    },

    moveUp: function () {
        const fieldView = Game.currentGame.field.onGetView();

        if (fieldView.realZOrder === undefined) {
            fieldView.realZOrder = fieldView.getLocalZOrder();
        }

        fieldView.setLocalZOrder(FieldBoostersView.ZORDER + 1);
    },

    moveDown: function () {
        const fieldView = Game.currentGame.field.onGetView();

        if (fieldView.realZOrder !== undefined) {
            fieldView.setLocalZOrder(fieldView.realZOrder);
        }
    },

    listBoosters: function () {
        return Object.values(this.views);
    }
});

FieldBoostersView.ZORDER = 5;

cleverapps.styles.FieldBoostersView = {
    background: false,
    hidingPosition: [
        { x: { align: "center" }, y: { align: "bottom", dy: -660 } },
        { x: { align: "right", dx: 650 }, y: { align: "center" } },
        { x: { align: "right", dx: 650 }, y: { align: "center" } }
    ],
    position: [
        { x: { align: "center" }, y: { align: "bottom", dy: 10 } },
        { x: { align: "right" }, y: { align: "center" } },
        { x: { align: "right" }, y: { align: "center" } }
    ],
    sizes: [
        {
            width: 720,
            height: 200
        },
        {
            width: 190,
            height: 650
        },
        {
            width: 190,
            height: 650
        }
    ],
    delay: 0
};
